<template >
    <div class="right_box_main">
        <div class="listBox-item">
            
            <el-card>
                <div class="fisthang">
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item label="类型" style="margin:0 30 0 0;">
                            <el-select
                                size="mini"
                                v-model="searchlist.activeStatus"
                                placeholder="请选择"
                                style="width:100px"
                                clearable
                            >
                                <el-option label="问题" value="1"></el-option>
                                <el-option label="建议" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="处理状态" style="margin:0 30 0 0;">
                            <el-select
                                size="mini"
                                v-model="searchlist.activeStatus"
                                placeholder="请选择"
                                style="width:100px"
                                clearable
                            >
                                <el-option label="待处理" value="1"></el-option>
                                <el-option label="处理中" value="2"></el-option>
                                <el-option label="已处理" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户评价" style="margin:0 30 0 0;">
                            <el-select
                                size="mini"
                                v-model="searchlist.activeStatus"
                                placeholder="请选择"
                                style="width:100px"
                                clearable
                            >
                                <el-option label="待评价" value="1"></el-option>
                                <el-option label="非常满意" value="2"></el-option>
                                <el-option label="满意" value="2"></el-option>
                                <el-option label="不满意" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="反馈日期" style="margin:0 30 0 0;">
                            <el-date-picker
                                v-model="value2"
                                type="datetimerange"
                                align="right"
                                size="mini"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-time="['12:00:00', '08:00:00']"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="标题" style="margin:0 30 0 0;">
                            <el-input placeholder="请输入标题" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="处理部门" style="margin:0 30 0 0;">
                            <el-select
                                size="mini"
                                v-model="searchlist.activeStatus"
                                placeholder="请选择"
                                style="width:100px"
                                clearable
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdata">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="listBox-item">
                    <!-- <el-button
                        style="margin-bottom:20px"
                        type="primary"
                        size="mini"
                        @click="showDialog('','add')"
                    >新增</el-button>-->
                    <!-- 表格盒子 -->
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="partyName" label="类型"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="标题"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="反馈者姓名"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="手机号"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="反馈者日期"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="处理部门"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="处理日期"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="处理状态"></el-table-column>
                            <el-table-column align="center" prop="partyPhone" label="用户评价"></el-table-column>

                            <el-table-column align="center" label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="查看"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-chakan tabBtn tabBtnCk"
                                            @click="showDialog(scope.row,'look')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="指派"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-zhuanzheng tabBtn tabBtnCk"
                                            @click="showDialog(scope.row,'zp')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="处理"
                                        placement="top-start"
                                    >
                                        <button
                                            class="iconfont icon-tongguos tabBtn tabBtnCk"
                                            @click="showDialog(scope.row,'cl')"
                                        ></button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                    </div>

                    <el-dialog
                        class="newDialog"
                        :title="add.title"
                        :visible.sync="add.off"
                        width="1100px"
                    >
                        <el-row>
                            <el-col :span="12">
                                <span>类型：</span>问题
                            </el-col>
                            <el-col :span="12">
                                <span>反馈者姓名：</span>张三
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span>反馈日期：</span>问题
                            </el-col>
                            <el-col :span="12">
                                <span>反馈者手机号：</span>张三
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span>标题：</span>问题
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span>内容：</span>内容
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <span>图片：</span>内容
                            </el-col>
                        </el-row>

                        <h5>任务指派</h5>
                        <el-form
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            label-width="100px"
                        >
                            <el-form-item label="处理部门" prop="partyName">
                                <el-select
                                    :disabled="type != 'zp'"
                                    v-model="value"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="处理时效" prop="partyName">
                                <el-date-picker
                                    :disabled="type != 'zp'"
                                    v-model="value1"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    size="mini"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="partyName">
                                <el-input
                                    :disabled="type != 'zp'"
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="textarea"
                                    size="mini"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                        <h5 v-if="type == 'cl' || type=='look'">处理</h5>
                        <el-form
                            v-if="type == 'cl' || type=='look'"
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            label-width="100px"
                        >
                            <el-form-item label="是否解决" prop="partyName">
                                <el-radio :disabled="type != 'cl'" v-model="radio" label="1">已完成</el-radio>
                                <el-radio :disabled="type != 'cl'" v-model="radio" label="2">未完成</el-radio>
                            </el-form-item>
                            <el-form-item label="回复结果" prop="partyName">
                                <el-input
                                    :disabled="type != 'cl'"
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="textarea"
                                    size="mini"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                        <h5 v-if="type == 'look'">评价</h5>
                        <el-row v-if="type == 'look'">
                            <el-col :span="24">
                                <span>评价结果：</span>非常满意
                            </el-col>
                        </el-row>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="onSubmit">立即{{add.title}}</el-button>
                        </span>
                    </el-dialog>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import { tabdata } from "@/mixins/tabledataMix.js";
export default {
    mixins: [tabdata],

    data() {
        return {
            ruleArr: {
                partyName: [
                    {
                        required: true,
                        message: "请输入政府名称",
                        trigger: "blur"
                    }
                ]
            },
            add: {
                form: {},
                off: false
            },
            type: ""
        };
    },
    methods: {
        onSubmit() {
            this.$refs.baseForm.validate(valid => {
                if (valid) {
                    if (this.type == "add") {
                        post(
                            "/admin/livelihoodsDisability/info/insertPartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("新增成功");
                            this.getPageDatas();
                        });
                    } else {
                        post(
                            "/admin/livelihoodsDisability/info/updatePartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("修改成功");
                            this.getPageDatas();
                        });
                    }
                } else {
                    //   console.log("error submit!!");
                    return false;
                }
            });
        },
        showDialog(row, type) {
            this.type = type;
            switch (type) {
                case "zp":
                    this.add.off = true;
                    this.add.title = "指派";
                    this.add.form = {};
                    break;
                case "cl":
                    this.add.off = true;
                    this.add.title = "处理";
                    this.add.form = {};
                    break;
                case "look":
                    this.add.off = true;
                    this.add.title = "查看";
                    this.add.form = JSON.parse(JSON.stringify(row));
                    break;
            }
        }
    },
    mounted() {
        this.initTableDataUrl(
            "/admin/livelihoodsDisability/info/listPartyPhone"
        );
    },
    created() {}
};
</script>

<style lang="less" scoped>
.icon-zhuanzheng {
    color: #2e99cf;
}
.icon-tongguos {
    color: #ff04ed;
}
.icon-chakan {
    color: #199b5d;
}
.newDialog {
    .el-row {
        margin: 20px 0px;
    }
    h5 {
        font-size: 20px;
        width: 100px;
        text-align: right;
        margin-bottom: 10px;
        margin-top: 20px;
    }
}
.el-col {
    span {
        display: inline-block;
        width: 100px;
        text-align: right;
    }
}
/deep/ .el-dialog__body {
    padding-top: 10px;
}
/deep/.el-dialog__footer {
    text-align: center;
}
</style>
 